"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Kesi2Home = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Kesi2Home, _React$Component);

  var _super = _createSuper(Kesi2Home);

  function Kesi2Home(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Kesi2Home);
    _this = _super.call(this, props);

    _NavigationManagerCordova["default"].goTo("".concat(_config["default"].baseRoute, "/").concat(_config["default"].rootId), null, true);

    return _this;
  }
  /*
  componentWillMount () {
    NavigationManagerCordova.goTo(`kesi2/${target.rootId}`, null, true)
  }
  */


  (0, _createClass2["default"])(Kesi2Home, [{
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Kesi2Home;
}(_react["default"].Component);

var _default = Kesi2Home;
exports["default"] = _default;